import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import TopBar from '../components/dashboard/TopBar';
import MobileBottomNav from '../components/layout/MobileBottomNav';
import AIFloatingWidget from '../components/dashboard/AIFloatingWidget';
import '../styles/design-tokens.css';
import './NewDashLayout.css';

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isChatPage = location.pathname.includes('ai-chat');

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="diwan-layout-root">
      {sidebarOpen && <div className="diwan-layout-backdrop" onClick={toggleSidebar}></div>}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="diwan-layout-main-panel">
        <TopBar onMenuClick={toggleSidebar} />
        <div className={`diwan-layout-content-area ${isChatPage ? 'is-chat-page' : ''}`}>
          <div className="diwan-content-scroll-wrapper">
            <Outlet />
            {!isChatPage && (
              <p className="diwan-layout-footer">
                حالياً في مرحلة التطوير، ترقبوا المزيد من الميزات قريباً!
                <br />
                © 2026 <strong>ديوان الأرض</strong>. كل الحقوق محفوظة.
                <br />
                برمجة وتصميم: <strong>محمد سلامة</strong> |
                فكرة ومحتوى ومسؤول عن التطوير والإدارة الرقمية: <strong>عبدالله جابر</strong> و <strong>محمد سلامة</strong>
              </p>
            )}
          </div>
        </div>
      </div>
      <MobileBottomNav />
      <AIFloatingWidget />
    </div>
  );
}

export default DashboardLayout;